import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/lib/format";
import type { AdminSurveyResponseItem } from "@/types/survey";

export function getSurveyResponseColumns(): ColumnDef<AdminSurveyResponseItem>[] {
  return [
    {
      accessorKey: "userName",
      header: "이름",
      cell: ({ row }) => (
        <div className="text-sm font-medium">{row.original.userName}</div>
      ),
    },
    {
      accessorKey: "userEmail",
      header: "이메일",
      cell: ({ row }) => (
        <div className="max-w-[180px] truncate text-sm text-muted-foreground" title={row.original.userEmail}>
          {row.original.userEmail}
        </div>
      ),
    },
    {
      accessorKey: "writerIdentity",
      header: "작가 정체성",
      cell: ({ row }) => (
        <span className="text-sm">{row.original.writerIdentity ?? "-"}</span>
      ),
    },
    {
      accessorKey: "writingFormat",
      header: "집필 형식",
      cell: ({ row }) => (
        <span className="text-sm">{row.original.writingFormat ?? "-"}</span>
      ),
    },
    {
      id: "genre",
      header: "장르",
      cell: ({ row }) => {
        const { genreValues, genreOtherText } = row.original;
        const parts = [
          ...(genreValues.length > 0 ? [genreValues.join(", ")] : []),
          ...(genreOtherText ? [genreOtherText] : []),
        ];
        if (parts.length === 0) return <span className="text-sm">-</span>;
        const display = parts.join(" / ");
        return (
          <div className="max-w-[150px] truncate text-sm" title={display}>
            {display}
          </div>
        );
      },
    },
    {
      accessorKey: "lastStepReached",
      header: "단계",
      cell: ({ row }) => (
        <span className="text-sm">{row.original.lastStepReached}/3</span>
      ),
    },
    {
      accessorKey: "surveyCompleted",
      header: "완료",
      cell: ({ row }) => (
        <Badge variant={row.original.surveyCompleted ? "default" : "secondary"}>
          {row.original.surveyCompleted ? "완료" : "미완료"}
        </Badge>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "가입일",
      cell: ({ row }) => (
        <div className="whitespace-nowrap text-sm">
          {formatDate(row.original.createdAt, { format: "short" })}
        </div>
      ),
    },
  ];
}
